/**
 * Level 7: Zen Spa ☯
 * 
 * A tranquil level with unique water aesthetics:
 * - Decorative water zones (not deadly)
 * - Slightly reduced gravity (0.85) for floaty feel
 * - Zen garden theme with bamboo aesthetics
 * - Wind zones for relaxing float
 * 
 * @module configs/levels/Level07_ZenSpa
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level07_ZenSpa = {
    id: 7,
    name: 'Zen Spa',
    subtitle: 'Tranquil Retreat',
    description: 'A peaceful sanctuary with soothing hot springs and bamboo.',
    
    worldWidth: 4500,
    worldHeight: 1400,
    playerStart: { x: 100, y: 1100 },
    gravity: 0.85, // Slightly floaty for zen feel
    
    theme: {
        bgGradient: ['#2d4a3e', '#1a2f27'],
        platformColor: 0x8B7355,
        accentColor: 0x90EE90,
        particleColor: 0xffffff,
        ambient: 'zen'
    },
    
    platforms: [
        { x: 0, y: 1200, w: 500, h: 40 },
        { x: 600, y: 1150, w: 80, h: 25 },
        { x: 750, y: 1100, w: 80, h: 25 },
        { x: 900, y: 1050, w: 80, h: 25 },
        { x: 1050, y: 1000, w: 300, h: 30 },
        { x: 1200, y: 850, w: 150, h: 20 },
        { x: 1450, y: 750, w: 120, h: 20 },
        { x: 1700, y: 1200, w: 400, h: 50 },
        { x: 2200, y: 1100, w: 100, h: 30 },
        { x: 2400, y: 1000, w: 100, h: 30 },
        { x: 2600, y: 900, w: 100, h: 30 },
        { x: 2850, y: 800, w: 250, h: 30 },
        { x: 3200, y: 1000, w: 200, h: 30 },
        { x: 3500, y: 1200, w: 400, h: 50 },
        { x: 4000, y: 1100, w: 500, h: 50 }
    ],
    
    movingPlatforms: [
        { x: 1600, y: 950, w: 80, h: 15, moveX: 100, speed: 0.001 },
        { x: 3100, y: 850, w: 100, h: 20, moveY: 150, speed: 0.0015 }
    ],
    
    spikes: [
        { x: 1150, y: 1000 },
        { x: 2900, y: 800 },
        { x: 3000, y: 800 }
    ],
    
    stars: [
        { x: 750, y: 1000 },
        { x: 1450, y: 650 },
        { x: 1900, y: 1100 },
        { x: 2600, y: 800 },
        { x: 3350, y: 900 },
        { x: 4200, y: 1000 }
    ],
    
    enemies: [
        { x: 1100, y: 950 },
        { x: 2950, y: 750 },
        { x: 3600, y: 1150 }
    ],
    
    door: { x: 4300, y: 950, w: 50, h: 300 },
    button: { x: 3900, y: 1095 },
    box: { x: 2975, y: 750, floating: true }, // MAGNETIC BOX
    goal: { x: 4400, y: 1000 },
    
    trampolines: [
        { x: 1850, y: 1200, w: 60 }
    ],
    
    windZones: [
        { x: 1750, y: 1000, w: 300, h: 250, direction: 'up', force: 0.0015 }
    ],
    
    waterZones: [
        { x: 500, y: 1250, w: 1000, h: 150 }
    ],
    
    speedrunTargets: { gold: 45, silver: 65, bronze: 90 }
};

export default Level07_ZenSpa;
